import React from "react";
import { Row, Col, Container, Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";

import './registerRequest.css';

const RegisterRequest = () => {
  return (
    <Row>
      <Col xs="12" md="12" lg="12" className="pt-5 bg-dark text-center">
        <h1 className="mt-5 text-light">Formulário de Registro Programa NSC Escola</h1>
      </Col>
      <Col>
        <Container className="container-request">
          <Form>          
            <div className="col-12">
            <FormGroup>
              <Label for="school-namel">Nome da Escola</Label>
              <Input
                type="text"
                name="school-name"
                id="school-name"
                placeholder="Nome da Escola"
              />
            </FormGroup>
            </div>
            <div className="col-12 col-md-12 col-lg-6 col-xl-6">
            <FormGroup>
              <Label for="exampleEmail">Email</Label>
              <Input
                type="email"
                name="email"
                id="email"
                placeholder="with a placeholder"
              />
            </FormGroup>
            </div> 
            <div className="col-12 col-md-12 col-lg-6 col-xl-6">
            <FormGroup>
              <Label for="password">Senha</Label>
              <Input
                type="password"
                name="password"
                id="password"
                placeholder="Digite sua senha"
              />
            </FormGroup>
            </div>
            <div className="col-12 col-md-12 col-lg-6 col-xl-6">
            <FormGroup>
              <Label for="qtd-alunos-escola">Quantos alunos sua escola possui?</Label>
              <Input type="select" name="select" id="qtd-alunos-escola">
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </Input>
            </FormGroup>
            </div>
            <div className="col-12">
            <FormGroup>
              <Label for="school-cover">Faça um Resumo sobre sua Escola</Label>
              <Input type="textarea" name="text" id="school-cover" />
            </FormGroup>
            <FormGroup>
              <Label for="upload-school-docs">File</Label>
              <Input type="file" name="file" id="upload-school-docs" />
              <FormText color="muted">
                Faça Upload dos documentos referentes sua escola. 
              </FormText>
            </FormGroup>
            <FormGroup tag="fieldset">
              <legend>Escolha uma opção abaixo</legend>
              <FormGroup check>
                <Label check>
                  <Input type="radio" name="radio1" /> Minha Escola possui turmas participantes do Enem</Label>
              </FormGroup>
              <FormGroup check>
                <Label check><Input type="radio" name="radio1" /> Minha Escola não possui turmas participantes do Enem</Label>
              </FormGroup>    
            </FormGroup>
            <FormGroup check>
              <Label check><Input type="checkbox" /> Envie-me uma cópia deste registro </Label>
            </FormGroup>
            <Button color="primary" size="lg" className="mt-4 mb-5">Cadastrar Escola</Button>          
          </div>          
          </Form>
        </Container>
      </Col>
    </Row>
  );
};

export default RegisterRequest;
